import { Link } from "gatsby"
import React from "react"
import * as styles from "./ariane.module.scss"

type ArianeProps = {
    breadcrumb: {
        title: string
        slug: string
        link: string
    }[]
    backgroundColor?: string
    pageContext: {
        locale: string
        defaultLocale: string
    }
}

const Ariane = ({ breadcrumb, backgroundColor, pageContext }: ArianeProps) => {
    const defaultLocale = pageContext.defaultLocale
    const locale = pageContext.locale
    
    return (
        <div className={styles.ariane} style={{ backgroundColor: backgroundColor }}>
            {breadcrumb.map((page, index) => (
                <div key={index}>
                    <Link className={styles.link} to={page.link === "/" ? 
                        locale === defaultLocale ? "/" : `/${locale}/`
                        : locale === defaultLocale ? `/${page.link}` : `/${locale}/${page.link}`}>
                        {page.title}
                    </Link>
                    {index < breadcrumb.length - 1 && <span className={styles.separator}>·</span>}
                </div>
            ))}
        </div>
    )
}

export default Ariane